import React from 'react'
import i18n from 'i18next'

const STATUS = {
    active: 1,
    development: 2,
    closed: 3,
}

const StatusBadge = ({ status }) => (
    <div className={`survey-status-badge survey-status-badge--${status}`}>
        <i className={`fa-${status === 'development' ? 'regular' : 'solid'} fa-circle`} />

        <p>{i18n.t(`status_${STATUS[status]}_rebrand`)}</p>
    </div>
)

export default StatusBadge
